import { render } from "./GLView.vue?vue&type=template&id=714bc349&ts=true"
import script from "./GLView.vue?vue&type=script&lang=ts"
export * from "./GLView.vue?vue&type=script&lang=ts"

import "./GLView.vue?vue&type=style&index=0&id=714bc349&lang=stylus"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__